import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BusinessProductPaymentManagerPage } from '../business-product-payment-manager/business-product-payment-manager';
import { BusinessProductSearchPage } from '../business-product-search/business-product-search';
import { BusinessProductPaymentInvoiceListPage } from '../business-product-payment-invoice-list/business-product-payment-invoice-list';
import { BusinessProductExpediterInvoiceListPage } from '../business-product-expediter-invoice-list/business-product-expediter-invoice-list';

@Component({
  selector: 'page-business-product-payment-main',
  templateUrl: 'business-product-payment-main.html',
})
export class BusinessProductPaymentMainPage {

	// cashier = BusinessProductPaymentManagerPage;
  cashier = BusinessProductSearchPage;
	openOrders = BusinessProductExpediterInvoiceListPage;
	invoices = BusinessProductPaymentInvoiceListPage;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessInvoiceMainPage');
  }

}


// WEBPACK FOOTER //
// ./src/pages/business-product-payment-main/business-product-payment-main.ts